'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.default = BasicError;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.toarray');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BasicError(_ref) {
  var error = _ref.error;

  return _react2.default.createElement(
    'span',
    null,
    error && _react2.default.createElement(
      'div',
      { className: 'alert alert-danger', role: 'alert' },
      (typeof error === 'undefined' ? 'undefined' : (0, _typeof3.default)(error)) === 'object' && (0, _lodash2.default)(error).map(function (errField, field) {
        errField = typeof errField === 'string' ? [errField] : errField; // eslint-disable-line no-param-reassign
        return (0, _lodash2.default)(errField).map(function (err, index) {
          return _react2.default.createElement(
            'p',
            { key: 'err-' + field + '-' + index },
            _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
            _react2.default.createElement(
              'span',
              { className: 'sr-only' },
              'Error:'
            ),
            ' ' + err
          );
        });
      }),
      typeof error === 'string' && _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          'Error:'
        ),
        ' ' + error
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/BasicError.js
// module id = 2199
// module chunks = 0